import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';
import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { ActionBar, ActionBarElementType, Button, ButtonVariant } from '@dreryk/react-components';

import { visitActionBarTranslationKeys } from '../../translations';

import { PrescriptionVisitDataModalOpener } from './PrescriptionVisitDataModal.opener';

type PrescriptionVisitDataActionProps = {
   readonly visit: Visit;
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const PrescriptionVisitDataAction = (props: PrescriptionVisitDataActionProps): JSX.Element => {
   return (
      <PrescriptionVisitDataModalOpener visit={props.visit} chronicDiseases={props.chronicDiseases}>
         {({ openModal }) => (
            <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
               <Button
                  testId={'prescriptionVisitData'}
                  label={visitActionBarTranslationKeys.prescriptionVisitData.label}
                  variant={ButtonVariant.SECONDARY}
                  onClick={openModal}
                  compact
               />
            </ActionBar.Portal>
         )}
      </PrescriptionVisitDataModalOpener>
   );
};
